export class MfaSetup {
  qrCode!: string;
  secret!: string;
}


